

























import { mapState } from 'vuex'

export default { 
  name: 'MenuDrawer'

  methods:
    logout: () ->
      @$store.dispatch 'logout'
      @$router.push '/login'
      
  computed:
    mapState
      user: (state) ->
        state.user
}




// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/components/MenuDrawer.vue